
// Design tokens da tela de templates do Messenger.
// Pagina/filtros/drawer seguem o mesmo violeta do design system (a tela vive ao lado
// da aba do WhatsApp; divergir a cor primaria quebraria a leitura das duas juntas).
// O que muda e o bloco `preview`: o mockup e do Messenger, nao do WhatsApp.
export const TEMPLATES_MESSENGER_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-5 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-0.5"
        },
        actionButton: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95",
        secondaryButton: "border-gray-200 text-gray-600 hover:bg-gray-50 hover:text-gray-900 rounded-xl px-3.5 py-2.5 h-auto text-sm font-medium transition-all"
    },
    stats: {
        grid: "grid grid-cols-2 md:grid-cols-4 gap-3",
        card: "bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3 hover:shadow-sm transition-shadow",
        iconBox: "w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0",
        value: "text-xl font-bold text-gray-900",
        label: "text-xs text-gray-500"
    },
    filters: {
        grid: "grid grid-cols-1 md:grid-cols-3 gap-4",
        label: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 block",
        select: "w-full bg-white border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200",
        searchInput: "pl-9 bg-white border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200"
    },
    drawer: {
        overlay: "fixed inset-0 z-[9999] flex justify-end overflow-hidden animate-in fade-in duration-200",
        backdrop: "absolute inset-0 bg-black/40 backdrop-blur-[2px]",
        container: "relative w-[90%] max-w-7xl h-full bg-white shadow-2xl flex flex-col animate-in slide-in-from-right duration-300",
        header: {
            container: "flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-white",
            title: "text-base font-bold text-gray-900",
            subtitle: "text-xs text-gray-500 mt-0.5",
            actions: "flex items-center gap-3"
        },
        errorBanner: "flex items-start gap-3 bg-red-50 border-b border-red-100 px-6 py-3",
        content: {
            container: "flex-1 flex overflow-hidden min-h-0",
            leftColumn: "w-[62%] p-6 overflow-y-auto max-h-full border-r border-gray-100 bg-white",
            rightColumn: "w-[38%] p-6 overflow-y-auto max-h-full bg-gradient-to-b from-slate-50 to-slate-100/50",
            section: {
                container: "mb-6",
                titleWrapper: "flex items-center gap-3 mb-5",
                iconBox: "w-8 h-8 bg-[#F3E8FF] rounded-lg flex items-center justify-center text-[#7C3AED]",
                title: "text-base font-bold text-gray-900",
                label: "block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 flex items-center gap-2",
                input: {
                    base: "text-sm border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200",
                    disabled: "bg-gray-50 cursor-not-allowed text-gray-500"
                },
                card: "bg-white rounded-xl border border-gray-100 p-5"
            }
        },
        footer: {
            container: "border-t border-gray-100 bg-gray-50/80 px-6 py-3 flex items-center justify-between"
        },
        variaveis: {
            container: "bg-violet-50/50 rounded-xl border border-violet-100 p-4",
            chip: "bg-violet-100 text-violet-700 font-mono text-xs rounded px-1.5 py-0.5"
        },
        // Mockup do Messenger. Diferente do WhatsApp: o header do app e BRANCO com o
        // nome em preto, o fundo do chat e branco e a bolha de saida e azul #0084FF.
        preview: {
            phoneFrame: "bg-gray-900 rounded-[2.5rem] p-1.5 shadow-xl mx-auto max-w-[300px]",
            phoneInner: "bg-gray-900 rounded-[2rem] overflow-hidden",
            notch: "flex justify-center py-2 bg-gray-900",
            notchPill: "w-20 h-5 bg-gray-800 rounded-full",
            messengerHeader: "bg-white px-3 py-2.5 flex items-center gap-2.5 border-b border-gray-200",
            chatArea: "min-h-[320px] p-3 bg-white",
            // Template so com BODY: bolha de texto comum
            messageBubble: "bg-[#0084FF] text-white rounded-2xl px-3 py-2 shadow-sm max-w-[85%] min-w-[140px] ml-auto",
            // Template com HEADER/BUTTONS: a Conversation API entrega como generic template
            cardTemplate: "bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm max-w-[85%] ml-auto",
            cardImage: "w-full h-32 object-cover bg-gray-100",
            cardBody: "px-3 py-2.5",
            cardTitle: "text-[13px] font-semibold text-gray-900 leading-snug",
            cardSubtitle: "text-[12px] text-gray-600 mt-1 leading-snug whitespace-pre-wrap",
            cardButton: "w-full py-2.5 text-[13px] font-semibold text-[#0084FF] border-t border-gray-200 hover:bg-gray-50 transition-colors",
            // Variavel destacada dentro da bolha azul — bg-blue-100/text-blue-700 do
            // WhatsApp nao tem contraste sobre azul
            variavelNaBolha: "bg-white/25 rounded px-1 font-semibold",
            variavelNoCard: "bg-blue-50 text-blue-700 rounded px-1 text-[11px] font-semibold",
            inputBar: "bg-[#f0f0f0] px-2 py-2 flex items-center gap-2",
            homeIndicator: "flex justify-center py-2 bg-gray-900"
        }
    },
    card: {
        container: "group hover:shadow-lg transition-all duration-300 cursor-pointer border border-gray-200 hover:border-[#7C3AED]/40 hover:ring-1 hover:ring-[#7C3AED]/10 rounded-xl bg-white overflow-hidden"
    }
};
